export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    content: string
    allowHtml: boolean
    allowNoticeCard: boolean
}

const HTML_CONTENT = `# HTML 与安全策略

<mark>这段高亮文字依赖 allowHtml。</mark>

<notice-card title="发布建议" data-track="xmarkdown-demo-card">先确认允许的标签和属性，再开放给业务接入。</notice-card>

更多规范可以参考 <a href="https://design.ksyun.com/" target="_blank">King Design</a>。`;

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            content: HTML_CONTENT,
            allowHtml: true,
            allowNoticeCard: true,
        };
    }

    getSanitizeOptions() {
        if (!this.get('allowNoticeCard')) return undefined;

        return {
            ADD_TAGS: ['notice-card'],
            ADD_ATTR: ['title', 'data-track'],
        };
    }

    @bind
    setAllowHtml(allowHtml?: boolean) {
        this.set('allowHtml', !!allowHtml);
    }

    @bind
    setAllowNoticeCard(allowNoticeCard?: boolean) {
        this.set('allowNoticeCard', !!allowNoticeCard);
    }
}